export const CUSTOMER_SUBSCRIBER_REPORT_PERMISSION = {
  VIEW: 'CUSTOMER_SUBSCRIBER_REPORT_VIEW',
};
